

export enum FileKind {
	FILE,
	FOLDER,
	ROOT_FOLDER
}
